import { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const METRIC_MASTERDATA_RESOURCE = "metric" as const;
export const METRIC_MASTERDATA_OPERATION = "masterdata" as const;
export const METRIC_MASTERDATA_API_PATH = `/v1/${METRIC_MASTERDATA_RESOURCE}/${METRIC_MASTERDATA_OPERATION}` as const;

export type MetricMasterdataResponse =
  paths[typeof METRIC_MASTERDATA_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useMetricMasterdataQuery() {
  return useQuery({
    queryKey: [METRIC_MASTERDATA_RESOURCE, METRIC_MASTERDATA_OPERATION],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<MetricMasterdataResponse>(METRIC_MASTERDATA_API_PATH);
      return response.data;
    },
  });
}
